import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import Container from "../components/Container"

const HorzContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`

const Member = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const SubHeader = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: #000;
`

const Name = styled.p`
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000;
`
const Task = styled.p`
  font-size: 16px;
  text-align: center;
`
const ToolsSection = () => {
  const data = useStaticQuery(graphql`
    query {
      figma: file(relativePath: { eq: "figma.png" }) {
        childImageSharp {
          fixed(width: 80, height: 80, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      photoshop: file(relativePath: { eq: "Photoshop.png" }) {
        childImageSharp {
          fixed(width: 80, height: 80, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      intreview: file(relativePath: { eq: "Intreview.png" }) {
        childImageSharp {
          fixed(width: 100, height: 100, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      form: file(relativePath: { eq: "Form.png" }) {
        childImageSharp {
          fixed(width: 80, height: 80, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  return (
    <Container noTop>
      <SubHeader>Design and Research Tools</SubHeader>
      <HorzContainer>
        <Member>
          <Img fixed={data.figma.childImageSharp.fixed} />
          <Name>Figma</Name>
          <Task>
            Wireframing <br /> Prototyping
          </Task>
        </Member>
        <Member>
          <Img fixed={data.photoshop.childImageSharp.fixed} />
          <Name>Photoshop</Name>
          <Task>Graphic Design</Task>
        </Member>
        <Member>
          <Img fixed={data.form.childImageSharp.fixed} />
          <Name>Google Forms</Name>
          <Task>User Survey</Task>
        </Member>
        <Member>
          <Img fixed={data.intreview.childImageSharp.fixed} />
          <Name>User Interview</Name>
        </Member>
      </HorzContainer>
    </Container>
  )
}

export default ToolsSection
